import React from 'react';

const ColorTag = ({hexCode, followUpTypeName}) => {

    return <div className={"flex align-items-center"}>
        <div style={{backgroundColor: hexCode}} className={"mr-2 w-5 h-5"}/>
        <span className={''}>{followUpTypeName}</span>
    </div>;
};

export default ColorTag;